import React, { useState } from "react";
import { CompanyNewsTileType } from "@irati/types";
import tracking from "@irati-tracking/homepage";
import ContentHover from "./ContentHover";
import DeleteTileModal from "../DeleteTileModal";
import EditTileModal from "../NewContent/EditTileModal";
import Empty from "./Empty";
import Image from "./Image";
import LinkWrapper from "./LinkWrapper";
import Template from "./Template";
import Video from "./Video";
import { HomePageView } from "../../types";
import { StyledCol } from "./styled";
var ContentColumn = function (_a) {
    var companyNewsTile = _a.companyNewsTile, pageView = _a.pageView;
    var _b = useState(false), isOnHover = _b[0], setHover = _b[1];
    var _c = useState(false), showDeleteModal = _c[0], setShowDeleteModal = _c[1];
    var _d = useState(false), showEditModal = _d[0], setShowEditModal = _d[1];
    var isHoverStateEnabled = companyNewsTile.config.type !== CompanyNewsTileType.Empty && pageView === HomePageView.EDIT_CONTENT_VIEW;
    var columnWidth = companyNewsTile.config.columnWidth;
    return (React.createElement(StyledCol, { lg: columnWidth, md: columnWidth < 4 ? 6 : columnWidth, xs: 12, onMouseEnter: function () {
            if (isHoverStateEnabled) {
                setHover(true);
            }
        }, onMouseLeave: function () {
            if (isHoverStateEnabled) {
                setHover(false);
            }
        } },
        isHoverStateEnabled && (React.createElement(ContentHover, { handleDeleteTile: function () {
                tracking.homePageDeleteTileModal();
                setShowDeleteModal(true);
            }, handleEditTile: function () {
                setShowEditModal(true);
                setHover(false);
            }, isOnHover: isOnHover })),
        companyNewsTile.config.type === CompanyNewsTileType.Empty && pageView !== HomePageView.EMPLOYEE_VIEW && (React.createElement(Empty, { companyNewsTile: companyNewsTile })),
        companyNewsTile.config.type === CompanyNewsTileType.Image && (React.createElement(LinkWrapper, { companyNewsTile: companyNewsTile },
            React.createElement(Image, { companyNewsTile: companyNewsTile }))),
        companyNewsTile.config.type === CompanyNewsTileType.Video && React.createElement(Video, { companyNewsTile: companyNewsTile }),
        companyNewsTile.config.type === CompanyNewsTileType.Template && (React.createElement(LinkWrapper, { companyNewsTile: companyNewsTile },
            React.createElement(Template, { companyNewsTile: companyNewsTile }))),
        showDeleteModal && React.createElement(DeleteTileModal, { companyNewsTile: companyNewsTile, onClose: function () { return setShowDeleteModal(false); } }),
        showEditModal && React.createElement(EditTileModal, { companyNewsTile: companyNewsTile, onClose: function () { return setShowEditModal(false); } })));
};
export default ContentColumn;
